<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table
                            :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @row-click="goToDetail"
                            @import-items="importItems"
                            fileImportAccept=".csv,.xlsx"
                            ref="gofixTable">
                            <template slot="gofix_table:name_checklist_templates" slot-scope="row">
                                <template v-if="row.item.contract_term">
                                    <router-link target="_blank" class="text-dark" :to="`/v2/contract-client/${row.item.contract_term.contract_id}/checkList-template/${row.item.checklist_template_id}`">
                                       <span class="text-decoration-underline">{{ row.item.name_checklist_templates }}</span>
                                    </router-link>
                                </template>
                                <span class="text-decoration-underline" v-else>{{ row.item.name_checklist_templates }}</span>
                            </template>
                            <template slot="gofix_table:name" slot-scope="row">
                                <span>{{ (row.item.name != null && row.item.name.length > 50) ? row.item.name.substring(0,50)+"..." : row.item.name}}</span>
                            </template>
                            <template slot="gofix_table:unit_price" slot-scope="row">
                                {{ row.item.unit_price | formatMoney }}
                            </template>
                            <template slot="gofix_table:schedule" slot-scope="row">
                                <router-link class="text-dark" :to="`/v2/maintenance-program/${row.item.id}?tab=maint_schedule`">
                                    <span class="text-decoration-underline">View</span>
                                </router-link>
                            </template>
                            <template slot="gofix_table:actions" slot-scope="row">
                                <b-form-checkbox disabled></b-form-checkbox>
                            </template>
                            <template slot="gofix_table:after-import-modal" slot-scope="row" v-if="processIsEME">
                                <b-row>
                                    <b-col md="6">
                                        <gofix-form-dropdown
                                            label="Month"
                                            :clearable="false"
                                            :filterable="false"  
                                            fullContent
                                            :searchable="false"
                                            :options="modals.import.options.months"
                                            vLabel="text"
                                            :reduce="option => option.value"
                                            v-model="modals.import.data.month">
                                        </gofix-form-dropdown>
                                    </b-col>
                                    <b-col md="6">
                                        <gofix-form-dropdown
                                            label="Year"
                                            :clearable="false"
                                            :filterable="false" 
                                            :searchable="false"
                                            :options="modals.import.options.years"
                                            v-model="modals.import.data.year">
                                        </gofix-form-dropdown>
                                    </b-col>
                                </b-row>
                                <b-form-checkbox 
                                    class="ml-12"
                                    v-model="modals.import.data.allow_job_pte">
                                    <span class="d-flex align-items-center justify-content-center ml-10">Allows PTE job creation</span>
                                </b-form-checkbox>
                                <h6 class="mt-3"><u><i>EME Job Schedule Template - New Version</i></u></h6>
                                <gofix-button @click="downloadTemplate" label="EME-Job-Schedule-Template.xlsx" outline>
                                    <template  slot="gofix:button:afterLabel">
                                        <i class="icon-cloud-download icons font-xl ml-2"></i>
                                    </template>
                                </gofix-button>
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>

        <b-modal :no-close-on-backdrop="true" id="modal-Export-NLT-Message" hide-footer hide-header :centered="true" v-model="modals.importMessage.open">
            <div class="center">
                Your import has started and is currently being processed. <br/>You will receive another email once the import has been completed.
            </div>
            <b-button-group class="d-block text-right">
                <gofix-button label="CLOSE"  @click="modals.importMessage.open = false" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js'
    import moment from 'moment';

    export default {
        name: 'preventive-maintenance-program',
        components: {},
        data () {
            let filter = JSON.parse(JSON.stringify(filters['sor_master']));
            filter.is_maintenance.value = true;
            return {
                tableConfig:{
                    controls:{
                        create: null,
                        delete: null,
                        tableImport: process.env.VUE_APP_IS_EME == 'true' ? true : false,
                        tableExport: false,
                    },
                    name: 'maintenance-program',
                    filter: filter,
                    useDatabaseView: true,
                    page: 1,
                    limit: 100,
                    total: 0,
                    isCMS: 1
                },
                tableItems: [],
                modals: {
                    import: {
                        data: {
                            allow_job_pte: false,
                            month: null,
                            year: null,
                        },
                        options: {
                            months: [],
                            years: []
                        }
                    },
                    importMessage: {
                        open: false
                    },
                },
                processIsEME: process.env.VUE_APP_IS_EME == 'true',
            }
        },
        created() {
            if (process.env.VUE_APP_IS_EME == 'true') {
                this.modals.import.options.months = Array.from({ length: 12 }, (_, i) => {
                    const d = moment().month(i);
                    return {
                        text: d.format('MMMM'),
                        value: d.format('MM'),
                    };
                });

                const currentYear = moment().year();
                for (let i = currentYear - 10; i <= currentYear + 10; i++) {
                    this.modals.import.options.years.push(i);
                }

                this.modals.import.options.years = this.modals.import.options.years.reverse();
                this.modals.import.data.month = moment().format('MM');
                this.modals.import.data.year = currentYear;
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID',
            })
        },
        methods:{
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();                 
                    await this.$store.dispatch("v2SorController/getItems", tableRequest)
                        .then(response => {
                            this.tableItems = response.items;
                            this.tableConfig.total = response.total;
                            resolve(response);
                        })
                        .catch(err => {
                            this.$alertNotification("Can not load the maintenance program list", "danger");
                            reject();
                        })
                },
            goToDetail(item){
                let id = item.id || 0;
                return this.$router.push(`/v2/maintenance-program/${id}`);
            },
            async importItems(callback) {
                const {file, resolve, reject} = await callback();
                if(!this.ClientContractID || !this.ClientContractID.id) {
                    this.$alertNotification("Please select a contract selector.", "danger");
                    resolve({
                        isError: true
                    });
                    return;
                }
                if(!this.modals.import.data.month || !this.modals.import.data.year) {
                    this.$alertNotification("Please select a month and year.", "danger");
                    resolve({
                        isError: true
                    });
                    return;
                }
                this.$store.dispatch(`JobController/importEMEJobs`, {
                    file_import: file,
                    client_contract_id: this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : null,
                    allow_job_pte: this.modals.import.data.allow_job_pte,
                    date: moment(`${this.modals.import.data.year}-${this.modals.import.data.month}-01`).format("YYYY-MM-DD")
                }).then(() => {
                    this.modals.import.data.allow_job_pte = false;
                    this.modals.import.data.month = moment().format('MM');
                    this.modals.import.data.year = moment().year();
                    this.modals.importMessage.open = true;
                    resolve();
                })
                .catch(err => {
                    reject(err);
                })
            },
            downloadTemplate() {
                let time = moment().valueOf();
                let link = document.createElement('a');
                link.href = `${process.env.VUE_APP_SERVER_URL}/template/eme-import-job-schedule-template.xlsx?v=${time}`;
                link.setAttribute('download', 'EME-Job-Schedule-Template.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },
        }
    }
</script>
